export default "__VITE_ASSET__DABRNAqF__"